<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » アンケート結果ダウンロードの説明
  </div>
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>アンケート結果ダウンロードの説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/enquete.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 作成ボタン
        </div>
        <div class="manual-explain">
          クリックすることで作成画面が表示されます。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 削除ボタン
        </div>
        <div class="manual-explain">
          クリックすることで選択したファイルを削除します。<br>
          ボタンは、一覧の削除チェックボックスにチェックを入れる事で活性化されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter
        </div>
        <div class="manual-explain">
          アンケート結果ダウンロードファイル一覧に表示されているデータのフィルタリングを行います。<br>
          ※フィルタリングの対象: メモ
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> アンケート結果ダウンロードファイル一覧
        </div>
        <div class="manual-explain">
          作成済みのアンケート結果ダウンロードファイル一覧が表示されます。<br>
          編集アイコンをクリックすることで編集画面が表示されます。<br>
          また、ダウンロードボタンをクリックすることで作成されたファイルをダウンロードします。<br>
          ※ダウンロードボタンは、ファイル作成が完了した段階で活性化されます。<br>
          ※アンケートの件数が０件の場合は活性化されません。
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">Manual Top</a> » Survey Results Download Description
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

      <mat-card class="manual-card">
        <mat-card-header>
          <mat-card-title><span>Survey Results Download Description</span></mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <div class="manual-img">
            <img src="assets/img/manual/en_enquete.png" width="100%">
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/A.png"> Add Button
          </div>
          <div class="manual-explain">
            Clicking this button displays the creation screen.<br>
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/B.png"> Delete Button
          </div>
          <div class="manual-explain">
            Clicking this button deletes the selected files.<br>
            The button is activated by selecting the delete checkboxes in the list.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/C.png"> Filter
          </div>
          <div class="manual-explain">
            Filters the data displayed in the survey results download file list.<br>
            * Filtering Target: Memo
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/D.png"> Survey Results Download File List
          </div>
          <div class="manual-explain">
            Displays the list of created survey results download files.<br>
            Clicking the edit icon displays the edit screen.<br>
            Additionally, clicking the download button downloads the created file.<br>
            * The download button is activated once file creation is complete.<br>
            * If the number of survey entries is 0, the button will not be activated.
          </div>

        </mat-card-content>
      </mat-card>

  </div>

</div>